var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpressCare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#134A81"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M26.805 26.572c-.73-.139-1.677.06-2.841.598a.734.734 0 01-.854-.003c-.678-.494-1.986-1.547-3.118-3.07-1.17-1.575-1.682-3.262-1.882-4.126a.711.711 0 01.227-.698l1.273-1.097c.409-.353.611-.881.541-1.413l-.581-4.43a1.504 1.504 0 00-.751-1.118c-.412-.24-.9-.282-1.345-.11-1.532.585-4.147 2.015-4.439 5.024-.431 4.39 3.219 9.643 3.374 9.86.14.209 3.485 5.101 7.914 6.66a5.935 5.935 0 001.986.351c2.106 0 3.702-1.195 4.57-2.045.313-.3.475-.72.452-1.15a1.53 1.53 0 00-.591-1.115l-.394-.306c-2.293-1.599-2.446-1.604-3.541-1.812z"
  }))));
}
export default SvgExpressCare;